import { Plus, Trash2, Link2 } from 'lucide-react';
import { TextField } from '@anyemp/ui-kit';

const LinksEditor = ({ value = [], onChange, disabled = false }) => {
  const links = Array.isArray(value) ? value : [];

  const update = (index, patch) => {
    const next = links.map((l, i) => (i === index ? { ...l, ...patch } : l));
    onChange(next);
  };

  const add = () => {
    onChange([...links, { title: '', url: '' }]);
  };

  const remove = (index) => {
    onChange(links.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-1.5">
      {links.length === 0 ? (
        <p className="text-xs text-light-text-tertiary dark:text-dark-text-tertiary italic">No links</p>
      ) : (
        links.map((link, i) => (
          <div key={i} className="flex flex-wrap items-center gap-1.5">
            <Link2 className="h-3.5 w-3.5 text-light-text-tertiary dark:text-dark-text-tertiary flex-shrink-0" />
            <TextField
              type="text"
              size="small"
              placeholder="Title"
              value={link.title || ''}
              onChange={(e) => update(i, { title: e.target.value })}
              disabled={disabled}
              sx={{ root: 'flex-1' }}
            />
            <TextField
              type="url"
              size="small"
              placeholder="https://..."
              value={link.url || ''}
              onChange={(e) => update(i, { url: e.target.value })}
              disabled={disabled}
              sx={{ root: 'flex-[2]' }}
            />
            {!disabled && (
              <button
                type="button"
                onClick={() => remove(i)}
                className="p-1 text-light-text-tertiary hover:text-red-600 dark:hover:text-red-400 transition-colors"
                title="Remove link"
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            )}
          </div>
        ))
      )}
      {!disabled && (
        <button
          type="button"
          onClick={add}
          className="inline-flex items-center gap-1 text-xs text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
        >
          <Plus className="h-3 w-3" /> Add link
        </button>
      )}
    </div>
  );
};

export default LinksEditor;
